import {
  CampaignBusinessModel,
  CampaignImpact,
  Digitalisation,
  CompanyStage,
  FundingStage,
  PartnershipBacked,
  Presence,
} from '../../enum/campaign-categorisation.enum';
import { CampaignDetailApprovalStatus } from '../../enum/campaign-detail-approval-status';
import { Partner } from '../partnership/partner';
import { Term } from '../share/term';
import { CampaignWhatsNew } from './campaign-whats-new';

export class CampaignInfo {
  isLegacySystem: boolean;
  name: string;
  videoUrl: string;
  foundersUrl: string;
  campaignId: number;
  summary: string;
  problem: string;
  solution: string;
  product: string;
  traction: string;
  customers: string;
  businessModel: string;
  market: string;
  competition: string;
  funding: string;
  vision: string;
  founders: string;
  team: string;
  investmentTerms: string;
  disclosure: string;
  campaignFAQs: Term[];
  campaignRisks: Term[];
  campaignHighlights?: { id: number; content: string }[];
  isDraft: boolean;
  campaignDetailApprovalStatus: CampaignDetailApprovalStatus;
  remark: string;
  reviewedAt: string;
  campaignWhatsNew: CampaignWhatsNew;
  partners: Partner[];
  campaignBusinessModels: CampaignBusinessModel[];
  campaignImpacts: CampaignImpact[];
  digitalisation: Digitalisation;
  companyStage: CompanyStage;
  fundingStage: FundingStage;
  partnershipBacked: PartnershipBacked;
  presence: Presence;
  useAiDesign: boolean;
  gammaEmbedUrl: string;
}
